import { render } from "./project.vue?vue&type=template&id=c7fb524a&scoped=true"
import script from "./project.vue?vue&type=script&lang=js"
export * from "./project.vue?vue&type=script&lang=js"

import "./project.vue?vue&type=style&index=0&id=c7fb524a&scoped=true&lang=css"

import exportComponent from "D:\\Project\\2022\\management-system\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7fb524a"]])

export default __exports__